import { ConfiguratorStep } from './ConfiguratorStep.model';
export class Configurator {
  constructor(public id: number,
    public name: string,
    public steps: ConfiguratorStep, ) {
  }
}
